import { MessageCircle } from "lucide-react";
import { BUSINESS } from "../data";

export default function FloatingWhatsApp() {
  return (
    <a
      href={BUSINESS.whatsappText}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp"
      aria-label="Message us on WhatsApp"
      className="fixed bottom-6 left-6 z-40 inline-flex items-center gap-2 bg-[#00F0FF] hover:bg-[#33F3FF] text-[#0A0C10] font-semibold text-sm pl-4 pr-5 py-3 rounded-full shadow-[0_0_40px_rgba(0,240,255,0.35)] transition-all hover:scale-105"
    >
      <MessageCircle className="h-4 w-4" />
      WhatsApp
    </a>
  );
}
